import React from "react";
import {
  List,
  Datagrid,
  TextField,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  required,
  Show,
  SimpleShowLayout,
  DateField,
  SearchInput,
  FilterButton,
  CreateButton,
  TopToolbar,
} from "react-admin";
import ExportAllButton from "../components/ExportAllButton";
import DynamicDropdownFilter from "../components/DynamicDropdownFilter";

const CodeSourceFilter = [
  <SearchInput
    source="q_name_codeRepository_endorProjectUuid_githubProjectId"
    alwaysOn
  />,
  <DynamicDropdownFilter
    label="Code Respository"
    source="codeRepository"
    resource="cve/code-sources"
  />,
  <DynamicDropdownFilter
    label="Endor Project UUID"
    source="endorProjectUuid"
    resource="cve/code-sources"
  />,
  <DynamicDropdownFilter
    label="Github Project ID"
    source="githubProjectId"
    resource="cve/code-sources"
  />,
];

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton />
    <ExportAllButton />
  </TopToolbar>
);

export const CodeSourceList = (props: any) => (
  <List
    {...props}
    filters={CodeSourceFilter}
    actions={<ListActions />}
    sort={{ field: "name", order: "ASC" }}
  >
    <Datagrid rowClick="show">
      <TextField source="name" />
      <TextField source="codeRepository" />
      <TextField source="endorProjectUuid" />
      <TextField source="githubProjectId" />
      <DateField source="lastScannedAt" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </Datagrid>
  </List>
);

export const CodeSourceShow = (props: any) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="name" />
      <TextField source="codeRepository" />
      <TextField source="endorProjectUuid" />
      <TextField source="githubProjectId" />
      <DateField source="lastScannedAt" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);

export const CodeSourceEdit = (props: any) => (
  <Edit {...props} redirect="show">
    <SimpleForm>
      <TextInput source="name" validate={required()} />
      <TextInput source="codeRepository" validate={required()} />
      <TextInput source="endorProjectUuid" />
      <TextInput source="githubProjectId" />
    </SimpleForm>
  </Edit>
);

export const CodeSourceCreate = (props: any) => (
  <Create {...props} redirect={"show"}>
    <SimpleForm>
      <TextInput source="name" validate={required()} />
      <TextInput source="codeRepository" validate={required()} />
      <TextInput source="endorProjectUuid" />
      <TextInput source="githubProjectId" />
    </SimpleForm>
  </Create>
);
